import { useEffect, useRef, useState } from 'react';
import './admin-content-landing.styles.scss';
import { Route, Routes } from 'react-router-dom';
import { getGameDataFromDb, getPackageFromDb } from '@/utils/getDataFromDb';
import AdminTemplateGames from './template-games.component';
import CreatePackage from './create-package.component';
import AdminAddElementModal from './add-element-modal.component';
import { ModalAlert } from '@/components/modal/modal.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import ManageContent from './manage-content.component';

const AdminContentLanding = ({
    owners
}) => {

    const [packageList, setPackageList] = useState(null);
    const [showAddElementModal, setShowAddElementModal] = useState(false);
    const [templateGames, setTemplateGames] = useState(null);
    const [alertMessage, setAlertMessage] = useState('');
    const approveRef = useRef();

    useEffect(() => {
        getPackages();
        getTemplateGames();
        changeDocumentTitle('Gamably Admin | Manage Content');
    }, [])



    async function getPackages() {
        getPackageFromDb({
            'callback': callback,
        });
        function callback(data) {
            setPackageList(data);
        }
    }

    function getTemplateGames() {
        getGameDataFromDb({
            'template': true,
            'once': true,
            'callback': callback,
        })
        function callback(data) {
            console.log(data);
            setTemplateGames(data);
        }
    }

    return (
        <div className='admin-content-landing'>
            <Routes>
                <Route path='' element={
                    <div className='admin-content-landing__content g-card'>
                        <div className='section-title with-icon'>
                            <span>Manage Content</span>
                        </div>
                        <hr />
                        <ManageContent
                            owners={owners} />
                    </div>
                }></Route>
                <Route path='templategames' element={
                    <div className='g-card'>
                        <AdminTemplateGames
                            templateGames={templateGames}
                            owners={owners}
                            packageList={packageList} />
                    </div>
                }></Route>
                <Route path='createpackage' element={
                    <CreatePackage
                        packageList={packageList} />
                }></Route>
            </Routes>
            <AdminAddElementModal
                show={showAddElementModal}
                cancel={() => setShowAddElementModal(false)}
                alertMessage={alertMessage}
                setAlertMessage={setAlertMessage} />
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage}
                onApprove={approveRef.current} />
        </div>
    )
}

export default AdminContentLanding